/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
import { UpgradeStateEnum } from '@/enums/autarkyUpgrade';
import { FinanceCardAnalyzeAdvData } from './types';

/**
 * 归属于自营升级用户的状态列表：
 *  1) INIT: 初始状态，未提交申请
 *  2) SUBMIT: 已提交申请，等待审核
 */
export const AUTARKY_UPGRADE_PROCESS_STATE = [
  UpgradeStateEnum.INIT,
  UpgradeStateEnum.SUBMIT,
];

/** 无标签首页-金融卡片广告位id */
export const TAGLESS_FINANCE_CARD_ADV_ID = 'f6467f619b906d1be4accc1205bc9f60';

export interface AdvCoreData {
  adm: {
    creative: Record<string, any>[], // 轮播数据
    ext: Record<string, any>, // 扩展字段
    impid: string,
    timestamp: string,
    traceId: string
  }[],
}

/**
 * 解析金融卡片的广告位数据
 * marketSource： 广告位图片的url
 * marketHeight: 广告位图片的高度
 */
export function analyzeFinanceCardAdvData<T extends AdvCoreData>(
  adxData: T,
): FinanceCardAnalyzeAdvData {
  if (adxData && adxData.adm && adxData.adm.length) {
    // 广告位数据
    const { creative } = adxData.adm[0] || [];
    const { segment = {} } = creative.length ? creative[0] : {};
    const marketSource = creative.length ? ((segment as Dictionary).img as string) : '';
    const marketHeight = creative.length ? `${(((creative[0].h as number) / 2 / 375) * 100)}vw` : '';
    const marketWidth = creative.length ? `${(((creative[0].w as number) / 2 / 375) * 100)}vw` : '';
    const marketUrl = creative.length ? creative[0].link : '';

    return {
      marketSource,
      marketHeight,
      marketWidth,
      marketUrl,
    };
  }

  return {};
}
